import { render, staticRenderFns } from "./MoneyBack.vue?vue&type=template&id=ddbebe50&scoped=true&"
var script = {}
import style0 from "./MoneyBack.vue?vue&type=style&index=0&id=ddbebe50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddbebe50",
  null
  
)

export default component.exports